import { useContext } from "react";
import { EstimateStructureContext } from "./EstimateStructureContext";

export const useEstimateStructure = () => {
  const context = useContext(EstimateStructureContext);
  if (context === null) {
    throw new Error("EstimateStructureContext cannot be null, please add a context provider");
  }
  return context;
};